import { FC } from 'react'
import { useAppSelector } from 'src/redux/storeHooks'
import Loader from 'src/utils/Loader'
import ProductDetail from './ProductDetail'
import NonOmsProductDetail from './NonOmsProductDetail'

const ProductDetailRoute: FC = () => {
  const { fetchedUserAccountData, fetchedUserAccountLoading } = useAppSelector(
    (state) => state.userAccountData
  )
  const isOmsAccount =
    fetchedUserAccountData?.userAdditionalInfo?.platform_connection_priority === 'OMS'

  if (!fetchedUserAccountData && fetchedUserAccountLoading) {
    return <Loader />
  }

  if (isOmsAccount) {
    return <ProductDetail />
  }

  return <NonOmsProductDetail />
}

export default ProductDetailRoute
